import { Component, OnInit } from '@angular/core';
import { AutenticacionService } from 'src/app/services/autenticacion.service';
import { FacadeSesionService } from 'src/app/services/facade-sesion.service';
import { EstadoRouteService } from 'src/app/services/estado-route.service';

@Component({
  selector: 'seleccion-modulos',
  templateUrl: './seleccion-modulos.component.html',
  styleUrls: ['./seleccion-modulos.component.scss']
})
export class SeleccionModulosComponent implements OnInit {

  constructor(
    private autenticacionService: AutenticacionService,
    private facadeSesionService: FacadeSesionService,
    private estadoRouteService: EstadoRouteService
  ) { }

  ngOnInit() {
    this.facadeSesionService.interfazService.mostrarBreadcrumb(false);
    this.estadoRouteService.mostrarBtnRetroceder$.next(false);
  }
  public cerrarSesion(): void {
    this.autenticacionService.cerrarSesion();
  }

}
